// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { UserDto } from '@marketplace-web/shared/user-data'

import { BusinessAccountDto } from '../types/business-account'

const isBusinessAccountDto = (dto: unknown): dto is BusinessAccountDto =>
  !!dto && typeof dto === 'object' && 'id' in dto

export const businessAccountFromUserDto = (dto: UserDto | null): BusinessAccountDto | null => {
  if (!isBusinessAccountDto(dto?.business_account)) return null

  return dto.business_account
}
